import React, { useEffect } from "react";
import close from "../../assets/images/New folder/close.png";
import { useTranslation } from "react-i18next";
import { motion, AnimatePresence } from "framer-motion";

const Dialog = ({ isOpen, closeDialog, description }) => {
  const { t } = useTranslation();

  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "unset";
    }

    return () => {
      document.body.style.overflow = "unset";
    };
  }, [isOpen]);

  useEffect(() => {
    const handleEscape = (e) => {
      if (e.key === "Escape" && isOpen) {
        closeDialog();
      }
    };

    window.addEventListener("keydown", handleEscape);
    return () => window.removeEventListener("keydown", handleEscape);
  }, [isOpen, closeDialog]);

  if (!isOpen) return null;

  return (
    <AnimatePresence>
      {isOpen && (
        <div className="fixed inset-0 flex items-center justify-center z-[999999]">
          {/* Backdrop with simple fade */}
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            transition={{ duration: 0.2 }}
            className="absolute inset-0 bg-black/60 backdrop-blur-sm"
            onClick={closeDialog}
          />

          {/* Dialog Container */}
          <motion.div
            initial={{ scale: 0.95, opacity: 0 }}
            animate={{ scale: 1, opacity: 1 }}
            exit={{ scale: 0.95, opacity: 0 }}
            transition={{ duration: 0.2 }}
            style={{ width: "calc(100% - 40px)" }}
            className="relative w-[90%] max-w-xl rounded-2xl overflow-hidden shadow-2xl bg-white"
          >
            {/* Header / Title */}
            <div className="bg-[#F05DA3]/10 px-6 py-4 flex items-center justify-between border-b border-gray-100">
              <h2 className="text-xl font-bold text-gray-800">
                {t("message")}
              </h2>
              <button 
                onClick={closeDialog}
                className="p-1 hover:bg-gray-100 rounded-full transition-colors"
              >
                <img
                  src={close}
                  alt="close"
                  className="w-5 h-5 opacity-50 hover:opacity-100"
                />
              </button>
            </div>

            {/* Main content container */}
            <div className="p-6 md:p-8">
              {/* Content area */}
              <div className="max-h-[50vh] overflow-y-auto custom-scrollbar">
                <p className="text-gray-700 text-base md:text-lg leading-relaxed text-center">
                  {description}
                </p>
              </div>

              {/* Action buttons section */}
              <div className="flex justify-center mt-6 gap-3">
                <button
                  onClick={closeDialog}
                  className="px-8 py-2.5 bg-[#F05DA3] text-white font-semibold rounded-full hover:bg-[#F05DA3]/90 transition-all active:scale-95 shadow-lg shadow-[#F05DA3]/20"
                >
                  {t("got it")}
                </button>
              </div>
            </div>
          </motion.div>
        </div>
      )}
    </AnimatePresence>
  );
};

export default Dialog;
